/* eslint-disable prettier/prettier */
<template>
  <div class="padding-10">
    <v-card
      class="white-background padding-5"
      :elevation="$root.ele"
      v-if="!isLoading"
    >
      <v-form v-model="isValid" ref="form">
        <Form v-model="form" @model-added="onModelAdded" @model-updated="onModelUpdated" @model-delete ="onModelDelete" @delete-updated-temp ="deleteUpdatedTemp"></Form>
      </v-form>
      <Footer :item="user" @update="update" @save="save"></Footer>
    </v-card>
  </div>
</template>

<script>
import Form from "./create/Form.vue";
import Footer from "./create/Footer";
import { appSetting, auth, carMake ,tempModels,fs, localUpdates} from "../../assets/js/firebase";
import { getDate } from "../../assets/js/common";
import { appLogsWrapper } from "../../assets/js/appLogsWrapper";
import { EventBus } from "../../main";
import appSettingModel from "../../assets/js/appSetting.model";

export default {
  components: {
    Footer,
    Form
  },
  data() {
    return {
      isValid: false,
      isLoading: true,
      form: {
        name: "",
        make_id: "",
        models: []
      },
      user: {},
      newModels: [],
      updatedModels: [],
      deletedModels: [], 
      copiedModels: []
    };
  },
  methods: {
    async save() {
      const vm = this;
      try {
        let { isValid, form } = vm;
        vm.$refs.form.validate();
        if (!isValid) return;
        vm.$root.loader = true;
        let date = getDate();
        let lower = form.name.toLowerCase();
        form.created_at = date;
        form.name_lower = lower;
        form.updated_at = date;
        form.updated_by = auth.currentUser.email;
        let snap = await carMake
          .where("name_lower", "==", lower)
          .limit(1)
          .get();
        let snapId = await carMake
          .where("make_id", "==", form.make_id)
          .limit(1)
          .get();
        if (!snap.empty) {
          vm.$root.loader = false;
          vm.$root.alert("A make already exists with same name");
          return;
        }
        if (!snapId.empty) {
          vm.$root.loader = false;
          vm.$root.alert("A make already exists with same ID");
          return;
        }
        console.log("ADDING OPERATION", JSON.stringify(form))
        await carMake.add(form);
        vm.$root.loader = false;
        vm.$router.replace("/car-make");
      } catch (error) {
        vm.$root.loader = false;
        vm.$root.alert(error.message);
        await appLogsWrapper({
          type: 'error',
          module: 'carMake',
          description: 'Error during car make insert',
          errorDetails: {
            message: error.message,
            stack: error.stack
          },
          createdBy: this.form.dataEntry || "-"
        });
      }
    },
    async update() {
      const vm = this;
      
      try {
        let { isValid, form } = vm;
        vm.$refs.form.validate();
        if (!isValid) return;
        vm.$root.loader = true;
        let lower = form.name.toLowerCase();
        let date = getDate();
        form.created_at = date;
        form.name_lower = lower;
        form.updated_at = date;
        form.updated_by = auth.currentUser.email;
        let { id } = vm.$route.params;
        let snap = await carMake
          .where("name_lower", "==", lower)
          .limit(1)
          .get();
        let snapId = await carMake
          .where("make_id", "==", form.make_id)
          .limit(1)
          .get();
        if (!snap.empty && snap.docs[0].id != id) {
          vm.$root.loader = false;
          vm.$root.alert("A make already exists with same name");
          return;
        }
        if (!snapId.empty && snapId.docs[0].id != id) {
          vm.$root.loader = false;
          vm.$root.alert("A make already exists with same ID");
          return;
        }
        
        let users = this.$store.getters.users;
        const userName = users.find((i) => i.email == auth.currentUser.email);
        let updatedBy = userName?.name;
        let email = auth.currentUser.email
        if(vm.newModels.length){
          vm.newModels.map(async (doc)=>{
            await tempModels.add({makeId : id, data : doc, createdAt: doc.createdAt, status: 'add', updatedBy, updated_by :email, updated_at: date});
          })
        }
         const latestData =await carMake.doc(id).get();
        latestData.data().models.forEach(dbModel => {
          let result = vm.checkSomeItem(form.models,dbModel);
          form.models = result;
        });
        // await carMake.doc(id).update(form);
        if(latestData.data().name_lower != form.name_lower || latestData.data().make_id != form.make_id){
          await carMake.doc(id).update({name: form.name, name_lower: form.name_lower, make_id: form.make_id, updated_at: date, updated_by: email});
        }
        
        if(vm.updatedModels.length){
          vm.updatedModels.map(async (doc)=>{
            await tempModels.add({makeId : id, data : doc, updatedAt: doc.updatedAt, modelId: doc.uId, updatedBy: updatedBy,  status: 'update', updated_by :email, updated_at: date});
          })
        }
        if(vm.deletedModels.length){
          vm.deletedModels.map(async (doc)=>{
            await tempModels.add({makeId : id, data : doc , deleteModelId : [doc.uId], status: 'delete',updatedBy, updated_by :email, updated_at: date});
          })
        }

        const querySnapshot = await localUpdates.where("makeId", "==", id).where("updated_by", "==", email).get();
        const batch = fs.batch();
        querySnapshot.forEach((doc) => {
        batch.delete(doc.ref);
        });
        await batch.commit();
        
        const afterUpdateSnapshot = await carMake.doc(id).get();
        const carMakeDataAfterUpdation = afterUpdateSnapshot.data();
        vm.$root.loader = false;
        vm.$router.replace("/car-make");
        if (form) {
          await appLogsWrapper({
            type: 'error',
            module: 'carMake new model',
            data: {before: form, after: carMakeDataAfterUpdation},
            description: 'Update does not reflex',
            createdBy: form.dataEntry || '-'
          });
        }
        // console.log("createcarkmake.vue ------------ AFTER ----", carMakeDataAfterUpdation?.models?.length);
        
      } catch (error) {
        vm.$root.loader = false;
        vm.$root.alert(error.message);
        await appLogsWrapper({
          type: 'error',
          module: 'carMake update',
          description: 'Error during car make update',
          errorDetails: {
            message: error.message,
            stack: error.stack
          },
          createdBy: this.form.dataEntry || "-"
        });
        
      }
    },
    async init() {
      const vm = this;
      let { name, params } = vm.$route;
      if (name === "car-make-update") {
        let { id } = params;
        vm.$root.loader = true;
        try {
          appSetting.doc(appSettingModel.realTimeSyncId).onSnapshot((doc) => {
            if(doc.exists){
              vm.realtimeSync = doc.data().realtimeSynchronization;
              
            }
          })
          carMake.doc(id).onSnapshot(async (doc) => {
        vm.$root.loader = false;
        if (!doc.exists) {
          vm.$root.alert("Make not found");
          vm.$router.replace("/car-make");
          return;
        }
        let { name, models, make_id } = doc.data();
        let email = auth.currentUser.email
        const querySnapshot = await localUpdates.where("makeId", "==", id).where("updated_by", "==", email).get();
        querySnapshot.forEach((doc) => {
          let dummy = {...doc.data()}
          dummy.oldName= null; 
          let index;
          for(let i=0;i< models.length ; i++){
            if(models[i].uId == dummy.uId){
              index = i
            }
          }
          if(index >=0){
              models.splice(index,1,dummy)
          }
        });
        if(vm.realtimeSync){
          EventBus.$emit('changeUpdateModelValue',models);
        }
        
        if (!make_id) make_id = "";
        vm.form = { name, models, make_id };        
        vm.isLoading = false;
      });
        } catch (error) {
          vm.$root.loader = false;
          vm.$root.alert(error.message);
        }
      } else {
        if(name === 'car-make-create') {
          vm.$root.loader = true;
          try {
            await carMake.doc().get();
            vm.$root.loader = false;
            vm.isLoading = false;
          } catch (error) {
            vm.$root.loader = false;
            vm.$root.alert(error.message);
          }
          
        } else {
          vm.$root.loader = false;
          vm.isLoading = false;
        }
      }
    },
    checkSomeItem(currentModels, databaseModel) {

  const updatedModels = currentModels.map((model) => {
    if (model.uId != databaseModel.uId) {
      return model;
    } else if (model.uId == databaseModel.uId) {
        let same = true;
        Object.keys(model).forEach(key =>{
          if(model[key] != databaseModel[key] && key != 'dataEntryLogs' && key != 'uId') {
            same = false;
          }
        });
        return same ? databaseModel : model;
    } else {
      // new addres
      currentModels.unshift(databaseModel);
      return databaseModel;
    }
  })
 
  return updatedModels;
  },
  onModelAdded(modelObj) {
    this.newModels.push(modelObj);
    },
  
  onModelUpdated(modelObj){
    this.updatedModels.push(modelObj);
  },
  onModelDelete(uId){
    this.deletedModels.push(uId);
  },
  deleteUpdatedTemp(doc){
    let index = this.updatedModels.findIndex(item => item.uId == doc.uId);
    this.updatedModels.splice(index,1)
  },
  // onModelCopy(modelObj){
  //   this.copiedModels.push(modelObj);
  // }  
  },
  mounted() {
    this.init();
  }
};
</script>

<style></style>
